import { render, staticRenderFns } from "./showcaseConfig.vue?vue&type=template&id=061d5f81&"
import script from "./showcaseConfig.vue?vue&type=script&lang=js&"
export * from "./showcaseConfig.vue?vue&type=script&lang=js&"
import style0 from "./showcaseConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports